import { LocaleCodes, LocaleCodesSlugPrefix } from '../../src/constants/localization.constants'

export const pageLocale = (slug: string) => {
  if (!slug) return LocaleCodes.ENGLISH
  if (slug[0] === '/') slug = slug.slice(1)
  const urlParts = slug.split('/')

  switch (urlParts[0]) {
    case LocaleCodesSlugPrefix.de:
      return LocaleCodes.GERMAN
    case LocaleCodesSlugPrefix.fr:
      return LocaleCodes.FRENCH
    case LocaleCodesSlugPrefix.pt:
      return LocaleCodes.PORTUGUESE
    case LocaleCodesSlugPrefix.es:
      return LocaleCodes.SPANISH
    case LocaleCodesSlugPrefix.ja:
      return LocaleCodes.JAPANESE
    case LocaleCodesSlugPrefix.ko:
      return LocaleCodes.KOREAN
    case LocaleCodesSlugPrefix.cn:
      return LocaleCodes.CHINESE
    case LocaleCodesSlugPrefix.tw:
      return LocaleCodes.TAIWAN
    default:
      return LocaleCodes.ENGLISH
  }
}
